import React, { useState } from "react";
import { Button, Col, Container, Row, Spinner } from "reactstrap";
import "../../assets/scss/datatables.scss";

//Import Breadcrumb
import Breadcrumbs from "../../Components/Common/Breadcrumb";

import { useDeleteAccount, useGetAccounts } from "hooks/useAccounts";

import { useNavigate } from "react-router-dom";
import { AccountCard } from "./components";
import { AppRoutes } from "../../constants";
import DeleteModal from "Components/Common/DeleteModal";
import { toast } from "react-toastify";
import { RootState } from "slices";
import { useSelector } from "react-redux";

const Account = () => {
  const selectedBranch = useSelector(
    (state: RootState) => state.branch?.currentBranch
  );

  const { data: accountsData, isLoading } = useGetAccounts(selectedBranch?.id);
  const { mutate } = useDeleteAccount();
  const navigate = useNavigate();
  //meta title
  document.title = "Pappermap | Accounts";
  const [resource, setResource] = useState<any>(null);
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [activeMenuIndex, setActiveMenuIndex] = useState<number | null>(null);

  // const toggleTab = (tab: any) => {
  //   if (activeTab !== tab) {
  //     setActiveTab(tab);
  //   }
  // };

  const toggleMenu = (index: number) => {
    setActiveMenuIndex(activeMenuIndex === index ? null : index);
  };

  const handleAddAccountClick = () => {
    navigate(AppRoutes.ADD_ACCOUNT);
  };

  const handleEditAccountClick = (id: any) => {
    navigate(`/edit-account/${id}`);
  };

  const handleViewAccountClick = (id: any) => {
    navigate(`/view-account/${id}`);
  };

  const onClickDelete = (item: any) => {
    setResource(item);
    setDeleteModal(true);
  };

  const handleDeleteAccount = () => {
    if (resource.id) {
      mutate(resource.id, {
        onSuccess: () => {
          toast.success("Account deleted successfully.");
        },
      });
      setDeleteModal(false);
    }
  };

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Account" breadcrumbItem="Wallet" />
          <div className="d-flex justify-content-end">
            <Button
              color="success"
              onClick={handleAddAccountClick}
              className="btn-rounded mb-4"
            >
              <i className="mdi mdi-plus me-1"></i>
              Add New Account
            </Button>
          </div>
          {accountsData && accountsData.length > 0 ? (
            <Row>
              {accountsData.map((item: any, index) => (
                <Col xl={4}>
                  <AccountCard
                    key={index}
                    account={item}
                    isMenu={activeMenuIndex === index}
                    toggleMenu={() => toggleMenu(index)}
                    onEditClick={() => handleEditAccountClick(item.id)}
                    onViewClick={() => handleViewAccountClick(item.id)}
                    onDeleteClick={() => onClickDelete(item)}
                  />
                </Col>
              ))}
            </Row>
          ) : (
            <div className="text-center mt-4">
              <i className="mdi mdi-alert-circle-outline mdi-36px text-warning"></i>
              <h5 className="mt-2">No accounts found</h5>
              <p>Please add an account to get started.</p>
            </div>
          )}
          {/* <Row>
            <Col lg={12}>
              {!isEmpty(accounts) && (
                <WalletActivities
                  walletHistory={accounts[0].price}}
                  activeTab={activeTab}
                  toggleTab={toggleTab}
                />
              )}
            </Col>
          </Row> */}
        </Container>
      </div>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteAccount}
        onCloseClick={() => setDeleteModal(false)}
      />
    </React.Fragment>
  );
};

export default Account;
